/* eslint-disable import/prefer-default-export */
import { API_URL } from '../../../../utils/config';

export const GET_RESCHEDULED_REQUEST_URL = `${API_URL}/RescheduledInstallations`;
